import { useState, useEffect, useRef } from 'react'
import { Box, Typography, Button } from '@mui/material'
import logo from '../../assets/rounded_logo.svg'

export default function TourSchedulingFrame() {
  const [isVisible, setIsVisible] = useState(false)
  const [hasAnimated, setHasAnimated] = useState(false)
  const frameRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasAnimated) {
          setIsVisible(true)
          setHasAnimated(true)
        }
      },
      {
        threshold: 0.33, // Trigger when 33% of the component is visible
        rootMargin: '0px 0px -50px 0px' // Start animation a bit before fully in view
      }
    )

    if (frameRef.current) {
      observer.observe(frameRef.current)
    }

    return () => {
      if (frameRef.current) {
        observer.unobserve(frameRef.current)
      }
    }
  }, [hasAnimated])
  return (
    <Box 
      ref={frameRef}
      sx={{
      position: 'relative',
      width: 280,
      height: 560,
      bgcolor: '#000',
      borderRadius: 6,
      p: 1,
      boxShadow: '0 20px 40px rgba(0,0,0,0.3)'
    }}>
      {/* iPhone Frame */}
      <Box sx={{
        width: '100%',
        height: '100%',
        bgcolor: 'white',
        borderRadius: 5,
        overflow: 'hidden',
        position: 'relative'
      }}>
        {/* Status Bar */}
        <Box sx={{
          height: 44,
          bgcolor: 'white',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-start',
          px: 2,
          fontSize: '0.875rem',
          fontWeight: 600
        }}>
          <Box
            component="img"
            src={logo}
            alt="HeyProperty"
            sx={{
              height: 40,
              width: 'auto',
              maxWidth: '60px',
              marginTop: '5px'
            }}
          />
        </Box>
        {/* Notification Banner */}
        <Box sx={{
          bgcolor: '#fef3c7',
          border: '1px solid #f59e0b',
          borderRadius: '8px',
          p: 2,
          mx: 2,
          mb: 2,
          mt: 1,
          textAlign: 'center',
          boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
          transform: isVisible ? 'translateY(0)' : 'translateY(-100px)',
          opacity: isVisible ? 1 : 0,
          transition: 'transform 0.6s cubic-bezier(0.34, 1.56, 0.64, 1), opacity 0.4s ease-out',
          position: 'relative',
          zIndex: 10
        }}>
          <Typography sx={{
            fontSize: '0.875rem',
            color: '#92400e',
            fontWeight: 500,
            lineHeight: 1.4,
            display: 'flex',
            alignItems: 'left',
            justifyContent: 'left',
            ml: 2,
            gap: 0.5,
          }}>
            🔥This is a hot listing<br/><br/>
            7 tours scheduled
          </Typography>
        </Box>

        {/* Tour Scheduling Content */}
        <Box sx={{ p: 3, textAlign: 'center' }}>  
          <Typography sx={{
            fontWeight: 700,
            fontSize: '1.25rem',
            color: 'grey.900',
            mb: 3
          }}>
            Available tour times
          </Typography>

          <Typography sx={{
            fontWeight: 600,
            fontSize: '1rem',
            color: 'grey.900',
            mb: 3
          }}>
            {(() => {
              const now = new Date();
              const nextMonth = new Date(now.getFullYear(), now.getMonth() + 1, 1);
              return nextMonth.toLocaleDateString('en-US', {
                weekday: 'long',
                month: 'long',
                day: 'numeric'
              });
            })()}
          </Typography>

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mb: 6 }}>
            <Button
              fullWidth
              variant="outlined"
              sx={{
                borderColor: 'grey.300',
                color: 'grey.900',
                textTransform: 'none',
                fontWeight: 600,
                py: 1.5
              }}
            >
              1:00 PM
            </Button>
            <Button
              fullWidth
              variant="outlined"
              sx={{
                borderColor: 'grey.300',
                color: 'grey.900',
                textTransform: 'none',
                fontWeight: 600,
                py: 1.5
              }}
            >
              1:30 PM
            </Button>
            <Button
              fullWidth
              variant="outlined"
              sx={{
                borderColor: 'grey.300',
                color: 'grey.900',
                textTransform: 'none',
                fontWeight: 600,
                py: 1.5
              }}
            >
              2:00 PM
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
